// extracted by mini-css-extract-plugin
export default {"backContainer":"styles_backContainer__V82W-","label":"styles_label__J0pO0","arrow":"styles_arrow__HYOq+"};